import { useEffect } from "react";

const SITE = "https://parkcomms.com";

function setMeta(attr, key, value) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

// Per-route SEO: title, description, self-referencing canonical, and matching
// Open Graph / Twitter tags. Pass noindex for admin/404 pages.
export function usePageSeo({ path, title, description, noindex = false }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (path) {
      const url = SITE + (path === "/" ? "/" : path);
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", url);
      setMeta("property", "og:url", url);
      setMeta("name", "twitter:url", url);
    } else {
      // No canonical for pages without a stable URL (e.g. 404) — remove any inherited one.
      const link = document.querySelector('link[rel="canonical"]');
      if (link) link.remove();
      setMeta("property", "og:url", SITE + "/");
      setMeta("name", "twitter:url", SITE + "/");
    }
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");
  }, [path, title, description, noindex]);
}
